import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { requiresEmailVerification } from './authVerification';
import { ROUTES } from './routes';

export default function ProtectedRoute({ children }) {
  const { authState } = useAuth();
  const location = useLocation();

  if (authState.loading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!authState.user) {
    return <Navigate to={ROUTES.login} replace state={{ from: location }} />;
  }

  if (requiresEmailVerification(authState.user)) {
    return <Navigate to={ROUTES.verifyEmail} replace state={{ from: location }} />;
  }

  return children;
}

